import React, { useEffect, useMemo, useState } from 'react'
import { Accordion, Label } from 'semantic-ui-react'
import { UILocalizations } from '../../redux/types/products'
import { useSelector } from 'react-redux'
import { AppState } from '../../redux/store'

const LocaleSpecificGridView = ({ productId }: { productId?: string }) => {
  const _localizations: UILocalizations = useSelector(
    (state: AppState) => state.products.localizations
  )
  const localizations = useMemo(
    () => (productId && _localizations[productId] ? _localizations[productId] : []),
    [productId, _localizations]
  )

  const [activePanels, setActivePanels] = useState<number[]>([])

  useEffect(() => {
    return () => {
      setActivePanels([])
    }
  }, [productId])

  const panels = useMemo(
    () =>
      localizations
        .filter((eachLocalization) => eachLocalization.id)
        .sort((l1, l2) =>
          `${l1.country}|${l1.subdivision}`.localeCompare(`${l2.country}|${l2.subdivision}`)
        )
        .map((eachLocalization, i) => ({
          active: activePanels.includes(i),
          onTitleClick: () => {
            if (activePanels.includes(i)) {
              setActivePanels((oldArray) => oldArray.filter((each) => each !== i))
            } else {
              setActivePanels((oldArray) => [...oldArray, i])
            }
          },
          key: eachLocalization.id,
          title: `${eachLocalization.country}-${eachLocalization.subdivision}`,
          content: {
            content: (
              <div>
                <b>Name:</b>
                <p>{eachLocalization.name || '(not set)'}</p>

                <b>Description:</b>
                <p>{eachLocalization.description || '(not set)'}</p>

                <b>Brand Subtype:</b>
                <p>{eachLocalization.category_label || '(not set)'}</p>

                <b>Lineage:</b>
                <p>{eachLocalization.lineage || '(not set)'}</p>

                <b>Images:</b>
                {eachLocalization.images ? (
                  eachLocalization.images.map((url: string) => (
                    <img alt="Localized pic here.." src={url} key={url} width={200} />
                  ))
                ) : (
                  <p>(not set)</p>
                )}
              </div>
            ),
            active: activePanels.includes(i),
          },
        })),
    [activePanels, localizations]
  )

  if (localizations?.length) {
    return (
      <div>
        <Label color="purple" horizontal pointing="below">
          Read-Only View of All Saved State-Specific Content
        </Label>
        <Accordion defaultActiveIndex={0} panels={panels} styled />
      </div>
    )
  } else {
    return null
  }
}

export default LocaleSpecificGridView
